import { Box, ListItem, Typography } from '@material-ui/core'
import { LanguageFlag } from 'components/facets/LanguageFlag'
import { CardLanguage, FINISH_TYPE_LABELS, flagCode, RichArticle } from 'shared'
import {
  FIRST_EDITION_ICON,
  FOIL_ICON,
  PLAYSET_ICON,
  REVERSE_HOLO_ICON,
  SIGNED_ICON,
} from 'utils/constants'
import { Card } from './Card/Card'
import { Condition } from './Condition'

interface LocalArticleProps {
  article: RichArticle
  showCard?: boolean
  showPrice?: boolean
  showComment?: boolean
  lineBreak?: boolean
  hideTitle?: boolean
}

export const LocalArticle = (props: LocalArticleProps): JSX.Element => {
  const {
    article: {
      quantity,
      isPlayset,
      condition,
      idLanguage,
      card,
      isFirstEd,
      isSigned,
      comment,
      price,
      finishType,
    },
    lineBreak,
    showCard = false,
    showComment,
    showPrice,
    hideTitle,
  } = props

  const shortenLongName = (name: string): string =>
    name.length < 21 ? name : name.slice(0, 21) + '...'

  const title = hideTitle
    ? `${quantity}x`
    : `${quantity}x ${shortenLongName(card.name)} ${card.set}`
  const attributes = (
    <>
      <Condition value={condition} />{' '}
      <LanguageFlag
        style={{ padding: '0px 5px' }}
        height="12"
        data-testid={`${CardLanguage[idLanguage]}-flag`}
        code={flagCode(idLanguage) || 'gg'}
      />{' '}
      {finishType === FINISH_TYPE_LABELS.FOIL && (
        <img data-testid="is-foil" alt="foil" height="18px" src={FOIL_ICON} />
      )}{' '}
      {isPlayset && <img data-testid="is-playset" alt="playset" height="18px" src={PLAYSET_ICON} />}
      {isFirstEd && (
        <img data-testid="is-first-ed" alt="first edition" height="18px" src={FIRST_EDITION_ICON} />
      )}
      {finishType === FINISH_TYPE_LABELS.REVERSE_HOLO && (
        <img data-testid="is-first-ed" alt="first edition" height="18px" src={REVERSE_HOLO_ICON} />
      )}
      {isSigned && (
        <img data-testid="is-signed" alt="first edition" height="18px" src={SIGNED_ICON} />
      )}
      {showComment && (
        <span style={{ padding: '0 3px' }}>
          {comment.length <= 15 ? comment : comment.slice(0, 15) + '...'}
        </span>
      )}
      {showPrice && (
        <Typography component={'span'} color="primary">
          {price}€
        </Typography>
      )}
    </>
  )
  if (lineBreak) {
    return (
      <Box
        style={{
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          maxWidth: '95%',
        }}
      >
        <ListItem>{showCard ? <Card card={card} /> : title}</ListItem>
        <ListItem>{attributes}</ListItem>
      </Box>
    )
  } else {
    return (
      <ListItem>
        {showCard ? <Card card={card} /> : title}
        {attributes}
      </ListItem>
    )
  }
}
